import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { RateLine } from 'src/app/modules/rates/_types/rate-line';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation, NotFilter } from 'src/app/core/jsonapi/filter';
import { firstValueFrom } from 'rxjs';
import { TransactionsLinesService } from 'src/app/modules/transactions/_services/transactions-lines.service';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { TransactionsService } from 'src/app/modules/transactions/_services/transactions.service';
import { TransactionsStatesService } from 'src/app/modules/transactions/_services/transactions-states.service';
import { TransactionsTypesService } from 'src/app/modules/transactions/_services/transactions-types.service';
import { Job } from 'src/app/modules/cases/_types/job';
import { JobsService } from 'src/app/modules/cases/_services/jobs.service';
import { TransactionLine } from 'src/app/modules/transactions/_types/transaction-line';
import { TasksRoutingModule } from 'src/app/modules/tasks/tasks-routing.module';
import { MessageService } from 'primeng/api';
import { CapabilitiesService } from 'src/app/modules/common/_services/capabilities.service';
import { Capability } from 'src/app/modules/common/_types/capability';
import { LoginService } from 'src/app/modules/login/login.service';
import { TransactionState } from 'src/app/modules/transactions/_types/transaction-state';

@Component({
    selector: 'app-case-service-transaction-lines',
    templateUrl: './case-service-transaction-lines.component.html',
    styleUrls: ['./case-service-transaction-lines.component.scss'],
    standalone: false
})
export class CaseServiceTransactionLinesComponent {

  public transactionLines: any[] = [];
  public totalTransactionLines!: number;
  public transactions: any = [];
  public transactionType: any = {};

  public companyId!: string;
  public workerId!: string;
  public providerId!: string;
  public caseServiceId!: string;
  public caseId!: string;
  public rateLines: RateLine[] = [];
  public hasSubmitInvoice: boolean = false;
  public allRateLines: any;
  public type!: string;
  public loadingTransactionLines: boolean = false;
  public selectedLines: any[] = [];
  public selectedTransaction: any;
  public capabilities: Capability[] = [];
  public selectedCapability: string | null = null;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public transactionId: any; //es para cuando está realacionado con importar lineas de presupuesto a otro presupuesto
  public transactionTypeEnableGroups: any;

  constructor(
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private transactionsService: TransactionsService,
    private transactionsStatesService: TransactionsStatesService,
    private transactionsTypesService: TransactionsTypesService,
    private transactionsLinesService: TransactionsLinesService,
    private jobsService: JobsService,
    private messageService: MessageService,
    private capabilitiesService: CapabilitiesService,
    private loginService: LoginService
  ) {
  }

  async ngOnInit() {

    let jobId = this.config.data.id;
    this.companyId = this.config.data.companyId;
    this.workerId = this.config.data.workerId;
    this.providerId = this.config.data.providerId;
    this.type = this.config.data.type;    
    this.caseServiceId = this.config.data.caseServiceId;
    this.caseId = this.config.data.caseId;
    this.transactionId = this.config.data.transactionId; //es para cuando está realacionado con importar lineas de presupuesto a otro presupuesto
    this.transactionTypeEnableGroups = this.config.data.transactionTypeEnableGroups; //es para cuando está realacionado con importar lineas de presupuesto a otro presupuesto

    this.allowWrite = this.loginService.hasPermission("CASES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES.DELETE");       

    this.loadData();
    this.loadCapabilities();

  }

  async loadData() {


    await this.loadTransactionType();

    let params: IParamsCollection = {
      include: ['transactionState', 'thirdParty', 'transactionType'],
    }
    
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, 'caseId', '', this.caseId),
      transactionStateCode: new  NotFilter(FilterOperation.equals, 'transactionState.code','', 'refused')
    };
    //solo si es un presupuesto de operario se saca los del operario, en la compñía se sacan todos.
    if(this.type != "COMPANY"){
      filters.transactionTypeId = new Filter(FilterOperation.equals, 'transactionTypeId', '', this.transactionType.id);
    }else{
      if(this.providerId != null && this.providerId != undefined && this.providerId != ""){
        //se muestran los presupuestos de cliente, de afectado, de compañía o solicitudes ed compra..
        filters.transactionTypeCode = new Filter(FilterOperation.any, "transactionType.code", '', ['purchase_order']);
        filters.thirdPartyId = new Filter(FilterOperation.equals, "thirdPartyId", '', this.providerId);
      }else{
        //se muestran los presupuestos de cliente, de afectado o de compañía.
        filters.transactionTypeCode = new Filter(FilterOperation.any, "transactionType.code", '', ['outgoing_budget', 'company_outgoing_budget', 'affected_outgoing_budget']);

      }
    }
    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.transactionsService.all(params));
    this.transactions = response.data;

    this.transactions.forEach((option:any) => {      
        const formatoPersonalizado = option.date.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }); 
        option.customName = formatoPersonalizado ?? "";

        if (option.code) {
            option.customName += (option.customName ? " - " : "") + option.code 
        }
        if(this.type == "COMPANY") option.customName += " (" + option.transactionType.name + ")";
    });
    if(this.type != "COMPANY" && this.providerId != null && this.providerId != undefined && this.providerId != ""){
      //si es con provider filtramos para que muestre sólo los suyos. No estoy 100% igual hay que poner que el 
      this.transactions = this.transactions.filter((m:any) => {
        return (m.thirdPartyType.toUpperCase() == 'PROVIDER' && m.thirdPartyId == this.providerId) || m.thirdPartyType.toUpperCase() != 'PROVIDER'
      })
    }

  }

  async loadCapabilities() {
    let response = await firstValueFrom(this.capabilitiesService.all());
    this.capabilities = response.data;
  }

  async loadTransactionType() {
    
    let params: IParamsCollection = {
    }
    //creamos filtros
    if(this.type == "COMPANY"){
      params.filter = FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '', "company_outgoing_budget") }).build();
    }
    if(this.type == "WORKER"){
      params.filter = FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '', "ingoing_budget_worker") }).build();
    }
    //Si es de proveedor se cargan las solicitudes de compra
    if(this.providerId != null && this.providerId != undefined && this.providerId != ""){
      params.filter = FilterBuilder.fromObject({ code: new Filter(FilterOperation.equals, 'code', '', "purchase_order") }).build();
    }
    
    let response = await firstValueFrom(this.transactionsTypesService.all(params));
    this.transactionType = response.data[0];
  }

  async loadTransactionLines() {

    this.selectedLines = [];

    let params: IParamsCollection = {
      sort: ["lineNumber"],
      include: ["rateLine.capability", "transaction"]
    }
    let filters: any = {
      transactionId: new Filter(FilterOperation.equals, "transactionId"),
    };
        
    filters.transactionId.value = this.selectedTransaction;
    if(this.selectedCapability){
      filters["rateLine.capabilityId"] = new Filter(FilterOperation.equals, "rateLine.capabilityId", "", this.selectedCapability
      );
    }
    params.filter = FilterBuilder.fromObject(filters).build();     

    let response = await firstValueFrom(this.transactionsLinesService.all(params));      

    this.transactionLines = response.data;          

    this.transactionLines.forEach((item) => {
      if(this.getInfoFromSelectedTransaction().transactionTypeCode == "purchase_order" && this.type == "COMPANY"){
        //Si es un proveedor. 
        //- si lo importado es SOLICITUDES DE COMPRA:
        //- si se pasa a compañía se pasa el total si se pasa o operario se pasa el de con el descuento 
        // El iva se calcula con respecto al total, no al descuento...R0013 de la excel.
        item.taxAmount =  parseFloat(((item.quantity * item.price)  * (item.taxPercent / 100)).toFixed(2)); 
        item.total =  (item.quantity * item.price) + item.taxAmount;
      }
    })
    
    this.totalTransactionLines = response.meta['total'];
    this.loadingTransactionLines = false;

  }

  // Función para generar el label concatenado
  getOptionLabel(option: any) {
    return option.code + " - " + option.description;
  }


  cancel() {
    this.dynamicDialogRef.close();
  }

  getInfoFromSelectedTransaction(): any{
     var target = "";
      var transactionTypeCode = "";
        if(this.selectedTransaction != null && this.selectedTransaction != undefined && this.selectedTransaction != ""){
          var transaction = this.transactions.filter((m:any) => m.id == this.selectedTransaction);
          if(transaction != null && transaction.length > 0){
            //transactionTypeCode = new Filter(FilterOperation.any, "transactionType.code", '', ['outgoing_budget', 'company_outgoing_budget', 'affected_outgoing_budget']);
            transactionTypeCode = transaction[0].transactionType.code;
            if(transaction[0].transactionType.code == "outgoing_budget"){
              target = "Client"; //0; //cliente
            }
            if(transaction[0].transactionType.code == "company_outgoing_budget"){
              target = "Company";  //compnay
            }
            if(transaction[0].transactionType.code == "affected_outgoing_budget"){
              target = "ThirdParty"; //implicados
            }
          }
        }
        return {
          target: target,
          transactionTypeCode: transactionTypeCode
        }
  }

  async saveLinesInTransaction(){
    //Creamos una línea de tranascción por cada línea de presupuesto seleccionada.
    try {
      //dependiendo de que tipo de transaccion seleccione, un target u otro.
      let params: IParamsCollection = { }        
      //creamos filtros
      params.filter = FilterBuilder.fromObject({code: new Filter(FilterOperation.equals, 'code', '', this.type)}).build();
  
      let response = await firstValueFrom(this.transactionsTypesService.all(params));    
      this.transactionType = response.data[0]; 

      // Se guardan una a una y en orden: el backend recalcula los totales de la transacción
      // leyendo las líneas ya guardadas en ese momento, así que guardarlas en paralelo provoca
      // que cada petición vea una foto distinta de las líneas y se pisen los totales entre sí.
      for (const line of this.selectedLines) {
        //se inserta si no es grupo o si lo es, si el destino acepta grupos.
        if(!line.isGroup || (line.isGroup && this.transactionTypeEnableGroups)){
          let newTransactionLine: TransactionLine = new TransactionLine();
          newTransactionLine = line;
          delete newTransactionLine.id;
          newTransactionLine.transactionId = this.transactionId;

          await firstValueFrom(this.transactionsLinesService.save(newTransactionLine));
        }
      }

      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Líneas guardadas correctamente." });

      this.dynamicDialogRef.close();
    } catch (error) {
      console.error(`Error al guardar alguna de las líneas: ${error}`);
    } 
  }

  async save() {    
    //Creamos job por cada linea
    try {
      //dependiendo de que tipo de transaccion seleccione, un target u otro.
      var target = "";
      var transactionTypeCode = "";
      var info = this.getInfoFromSelectedTransaction();
      target = info.target;
      transactionTypeCode = info.transactionTypeCode;

      const promesas = this.selectedLines.map((line, index) => {
        console.log("transactionTypeCode", transactionTypeCode, "line", line);
        let newJob: Job = new Job(); 
        newJob.target = target!= ""?target:"Company"; //No tengo claro esto, en algunos casos creo que habría que poder elegirlo auqneu ahora sea automatico. Ejemplo proveedores:importar presupuestos     
        newJob.caseServiceId = this.caseServiceId;
        newJob.caseId = this.caseId;
        newJob.date = new Date();
        newJob.workerId = this.workerId;
        newJob.rateLineId = line.rateLineId;
        newJob.unitPrice = line.price;
        newJob.quantity = line.quantity;
        newJob.total = line.subtotal + line.taxAmount;
        newJob.taxAmount = line.taxAmount;
        newJob.taxPercent = line.taxPercent;
        newJob.relatedInvoiceCode = (transactionTypeCode == "purchase_order" ? line.transaction?.relatedInvoiceCode : null);
        newJob.purchaseTransactionId = (transactionTypeCode == "purchase_order" ? line.transactionId : null);
        if(transactionTypeCode == "purchase_order" && this.type == "COMPANY"){
          //Si es un proveedor. 
          //- si lo importado es SOLICITUDES DE COMPRA:
          //- si se pasa a compañía se pasa el total si se pasa o operario se pasa el de con el descuento 
          // El iva se calcula con respecto al total, no al descuento...R0013 de la excel.       

          newJob.taxAmount =  parseFloat(((line.quantity * line.price)  * (line.taxPercent / 100)).toFixed(2)); 
          newJob.total =  (line.quantity * line.price) + line.taxAmount;

        }else{
          newJob.jobCompanyDiscountPercent = line.discountPercent;
          newJob.jobGuardCompanyIncrementPercent = line.incrementPercent;
        }
        newJob.isForCompany = this.type == "WORKER"?false:true;        
        newJob.description = line.description; //PREGUNTAR SI HAY QUE PASARLO TODO INDEPENDIENTEMENTE DE SI ES ACOMPAÑIA O A TRABAJADOR.
        newJob.providerId = this.providerId;
        
        return firstValueFrom(this.jobsService.save(newJob));  
      });
  
      // Espera que todas las promesas se resuelvan en paralelo
      await Promise.all(promesas);
      
      this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Trabajos guardados correctamente." });

      this.dynamicDialogRef.close();
    } catch (error) {
      console.error(`Error al guardar alguna de las líneas: ${error}`);
    }    
  }


}
